module.exports = __webpack_public_path__ + "img/logo.81e82b58.png";